/**
 * Background Icon
 * Large semi transparent background icon used on
 * many of the in app pages
 */
import { useTheme } from '@mui/material/styles';
import React from 'react';

import Icon from '@components/Icon/Icon';

import { vitallLogo } from '@images/background-icons/index';

import type { ImageType } from '@models/image-type';

import { resolveBackgroundIcon } from '@utils/resolveIcon';

import { FloatingIcon, FloatingImage } from './BackgroundIcon.style';

const BackgroundIcon: React.FC<{
  image?: ImageType;
}> = ({ image = 'logo' }) => {
  const theme = useTheme();
  const background = resolveBackgroundIcon(image, theme);
  return background ? (
    <FloatingIcon data-testid="bg-icon">
      <Icon
        name={background.iconName}
        rotation={-20}
        style={{ opacity: 0.03, verticalAlign: 0 }}
        type="far"
      />
    </FloatingIcon>
  ) : (
    <FloatingImage data-testid="bg-image" src={vitallLogo} />
  );
};

export default BackgroundIcon;
